import { Button, Icon, IconType, PageHeader } from '@lmc/ui-kit'
import HeaderIconContainer from 'components/generic/HeaderIconContainer'
import { ProTag } from 'components/ProTag'
import type React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

type Props = {
  handleToggleModal: () => void
  handleView: () => void
  disabledByPermission?: boolean
  testId?: string
}

const TitleContent = styled.div`
  display: flex;
  align-items: center;
`

export function CarerSkillsHeaderSection({
  handleView,
  handleToggleModal,
  disabledByPermission,
  testId
}: Props): React.ReactElement {
  const { t } = useTranslation()

  return (
    <PageHeader
      sticky
      title={
        <span style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <HeaderIconContainer $background="#EFEEFF">
            <Icon
              customIcon={IconType.LogoPurple}
              style={{ width: 26, height: 26 }}
            />
          </HeaderIconContainer>
          <TitleContent data-testid={testId ? `${testId}-title` : undefined}>
            {t(`skillsAndNeeds.skillsAndTrainings`)}
            <ProTag />
          </TitleContent>
        </span>
      }
      onBack={handleView}
      testId={testId}
    >
      <Button
        icon={<Icon name="PlusOutlined" />}
        variant="primary"
        disabledByPermission={disabledByPermission}
        onClick={handleToggleModal}
        data-testid={testId ? `${testId}-add-skill-button` : undefined}
      >
        {t(`skillsAndNeeds.assignNewSkillButton`)}
      </Button>
    </PageHeader>
  )
}

export default CarerSkillsHeaderSection
